import React, { ComponentType } from 'react';
import { CountryCode } from '../../../api/fetchLanguages';
import { config } from '../../../config';
import getQueryParams from '../../../helpers/getQueryParams';
import { Tenant } from '../../../utils/configurations';

export type InitialDataProps = {
  country: CountryCode | null;
  storeId: string | null;
  tenant: Tenant;
  source: string | null;
};

export const withInitialData =
  <P extends InitialDataProps>(
    Component: React.ComponentType<P>
  ): ComponentType<any> =>
  ({ ...props }: any): any => {
    const { country, storeId, source } = getQueryParams(
      'country',
      'storeId',
      'source'
    );
    const initialData: InitialDataProps = {
      /**
       * HACK:
       * There are some erratic re-directs in place that I cannot seem to find.
       * The solution for now is to not assume that url parameters are in the
       * right casing.
       *
       * @todo Implement proper validation of URL parameters.
       */
      country: country?.toUpperCase() ?? null,
      storeId,
      source,
      tenant: config.tenant,
    };

    return <Component {...initialData} {...(props as P)} />;
  };
